import { Attributes, LookupBase } from '@singularsystems/neo-core';

export default class InternalApproverLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly internalApproverId: number = 0;

    public readonly firstName: string = "";

    public readonly lastName: string = "";

    public readonly emailAddress: string = "";

    public readonly phoneNo: string = "";

    // Client only properties / methods

    @Attributes.DisplayMember()
    public get fullName(): string {
        return `${this.firstName} ${this.lastName}`;
    }
}